import React from "react";
import "./loading.css";

export const Loading: React.FunctionComponent = () => {
  return (
    <div className="Loading">
      <h2>Loading...</h2>
    </div>
  );
};
